"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function getRecaptcha3() {
  var data = {
    baseUrl: 'https://www.google.com/recaptcha/api.js',
    siteKey: '',
    isLoaded: false,
    isPending: false,
    scriptId: ''
  };
  return {
    init: function init(siteKey) {
      window['reactRecaptcha3Loaded'] = function () {
        data.isLoaded = true;
        data.isPending = false;
      };

      data.scriptId = +new Date();
      return new Promise(function (resolve, reject) {
        if (data.isLoaded || data.isPending) {
          resolve('success');
          return;
        } else {
          data.isPending = true;
          data.siteKey = siteKey;
          var script = document.createElement('script');
          script.innerHTML = '';
          script.src = data.baseUrl + "?render=".concat(data.siteKey, "&onload=reactRecaptcha3Loaded");
          script.id = "recapthcha-".concat(data.scriptId);
          script.async = true;
          script.defer = true;

          script.onload = function () {
            resolve('success');
          };

          script.onerror = function () {
            reject('error');
          };

          (document.head || document.boby).appendChild(script);
        }
      });
    },
    getToken: function getToken(action) {
      try {
        return window['grecaptcha'] ? window['grecaptcha'].execute(data.siteKey, action) : Promise.reject("grecaptcha is not initialized: Use ReactRecaptcha3.init(...)");
      } catch (e) {
        return new Promise(function (resolve, reject) {
          reject(e);
        });
      }
    },
    destroy: function destroy() {
      data.isLoaded = false;
      var script = document.getElementById("recapthcha-".concat(data.scriptId));

      if (script) {
        script.remove();
      }

      var badge = document.getElementsByClassName('grecaptcha-badge')[0];

      if (badge) {
        badge.remove();
      }

      window['grecaptcha'] = undefined;
    }
  };
}

var ReactRecaptcha3 = getRecaptcha3();
var _default = ReactRecaptcha3;
exports.default = _default;